import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SERVER_URL } from '../constants';
import { Stack } from '@mui/material';
import BasicTimePicker from './BasicTimePicker';
import { dateObjectToTimeString } from '../helpers/Helpers';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import dayjs from 'dayjs';
import CommonSnackbar from './CommonSnackbar';
import CircularProgress from '@mui/material/CircularProgress';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function AddTimeSlot (props) {

    const [open, setOpen] = useState(false);

    const [errorTitle, setErrorTitle] = useState("");
    
    const [errorMessage, setErrorMessage] = useState("");

    const [fetchingData, setFetchingData] = useState(true);

    const snackbar = {
        errorTitle,
        errorMessage,
        setErrorTitle,
        setErrorMessage
    }

    const handleClickOpen = () => {
        // console.log("props.latestTime", props.latestTime);
        // console.log("props.averageServeMinutes", props.averageServeMinutes);
        // console.log("props.startTime", props.startTime);
        fetchScheduleDetails();
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };

    const fetchScheduleDetails = () => {
            setFetchingData(true);
            const token = sessionStorage.getItem("token");
            fetch(SERVER_URL + 'api/mod/detail-schedule/' + props.scheduleId, {
                method: 'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization' : 'Bearer ' + token
                }
            })
            .then(response => response.json())
            .then(data => {
                // console.log("schedule data.data", data.data);
                setTime(getCalculatedTime(data.data.start_time, data.data.average_serve_minutes));
                setFetchingData(false);
            })
            .catch(err => console.error(err));
        }

    const getNextHour = () => {
        const now = dayjs();
        return now.minute() === 0 ? now.startOf('hour') : now.add(1, 'hour').startOf('hour');
    };

    const getCalculatedTime = (startTime, averageServeMinutes) => {
        const today = dayjs().format('YYYY-MM-DD');

        if (props.latestTime) {
            // If latestTime exists, add averageServeMinutes to it
            const latest = dayjs(`${today}T${props.latestTime}`);
            return latest.add(averageServeMinutes, 'minute');
        } else {
            // If latestTime does not exist, use startTime instead
            const start = dayjs(`${today}T${startTime}`);
            return start;
        }
    };

    // Initialize state with calculated time
    const [time, setTime] = useState(getCalculatedTime());



    const handleSave = () => {
        addTimeSlot();
        handleClose();
    }

    const addTimeSlot = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/create-timeslot',
        {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "time": dateObjectToTimeString(new Date(time)),
                "schedule_id": props.scheduleId,
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            if (data.status == 1) {
                if (typeof props.fetchTimeSlotList === 'function') {
                    props.fetchTimeSlotList();
                }
            } else {
                setErrorTitle("Error");
                setErrorMessage(data.message);
            }
        })
        .catch(err => console.error(err))
    }

    return(
        <React.Fragment>
            <CommonSnackbar snackbar={snackbar} />
            <IconButton
                    onClick={handleClickOpen}
                    size="medium"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
            <MoreTimeIcon fontSize='large' sx={{ color: 'gray' }} />
            </IconButton>
            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",  // Set your width here
                    },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={0}
                    >
                        <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                        Add Timeslot<br />
                        {props.date} 
                        </Typography>
                        <Typography variant="body1">
                        {props.officeName}
                        </Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Stack alignItems={"center"} spacing={2}>
                        {time && !fetchingData ?
                            <BasicTimePicker value={time} onChange={setTime} label="Select Time" ampm={true} minutesStep={5} />
                        : <CircularProgress size="1rem" /> }                        
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} >Cancel</Button>
                    <Button disabled={fetchingData} onClick={handleSave} >Add</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default AddTimeSlot;